import { create } from 'zustand';

// How many overlays are on screen. A counter, not a boolean: legacy `Modal`s stack, and a
// boolean would be cleared by whichever one closed first.
type OverlayStore = {
  open: number;
  openOverlay: () => void;
  closeOverlay: () => void;
};

const useOverlayStore = create<OverlayStore>((set) => ({
  open: 0,
  openOverlay: () => set((state) => ({ open: state.open + 1 })),
  // Clamped: an unbalanced close would go negative, and every `open > 0` consumer would then
  // stay visible through the next real overlay.
  closeOverlay: () => set((state) => ({ open: Math.max(0, state.open - 1) })),
}));

export default useOverlayStore;
